import { useMutation, useQueryClient } from '@tanstack/react-query';

type CustomizeType = 'candidate_profile' | 'company' | 'candidate_interview_log';

const RECORD_CLASS_NAME_MAP = {
  candidate_profile: 'CandidateProfile',
  company: 'Company',
  candidate_interview_log: 'CandidateInterviewLog',
} as const;

interface CreateCategoryParams {
  name: string;
  type: CustomizeType;
}

export default function useCreateCustomCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name, type }: CreateCategoryParams) => {
      const response = await fetch('/agent/api/custom_categories', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({
          name,
          record_class_name: RECORD_CLASS_NAME_MAP[type],
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || 'カテゴリの作成に失敗しました');
      }

      return response.json();
    },
    onSuccess: (data, variables) => {
      // カテゴリ一覧のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['custom_categories', variables.type] });
    },
  });
}
